module.exports = __webpack_public_path__ + "img/resource-tech-image-29.9e2ee763.jpg";